import { ComposeViewState } from 'owa-mail-compose-store';
import { AttachmentSuggestionsMenuItems } from 'owa-attachment-suggestions';

export function logAttachOrInsertMenuDismissed(
    composeViewState: ComposeViewState,
    getAttachmentSuggestionsMenuItems: () => AttachmentSuggestionsMenuItems | null,
    referenceAttachmentsSupported: boolean,
    classicAttachmentsSupported: boolean
) {
    const attachmentSuggestionsMenuItems = getAttachmentSuggestionsMenuItems();
    attachmentSuggestionsMenuItems?.onMenuDismissed(
        true /* shouldUseSuggestions */,
        composeViewState.referenceItemId,
        referenceAttachmentsSupported,
        classicAttachmentsSupported
    );
}
